export const EMPLOYEE = '/employee/applicant/';
export const DOCUMENTS = '/employee/documents/';
export const CLIENT_SETTINGS_URL = '/employee/client/';
